const { registerBlockType } = wp.blocks;
const { MediaUpload, MediaUploadCheck, RichText } = wp.blockEditor;
const { Button } = wp.components;
const { useEffect, useState } = wp.element;
import $ from "jquery";
import clientSlider from '../../../resources/scripts/module/clients-slider';

registerBlockType('mailmetrics/clients-logos', {
  title: 'Client Logos',
  icon: 'images-alt2',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    header: {
      type: 'string',
      default: 'WHO ELSE WE’VE DONE IT FOR'
    },
    logos: {
      type: 'array',
      default: [],
    },
  },

  edit: ({ attributes, setAttributes }) => {
    const { logos, header } = attributes;
    const [isAutoplay, setIsAutoplay] = useState(true);

    const toggleAutoplay = () => {
      const slider = $('[data-slider=clients]');
      if (slider.hasClass('slick-initialized')) {
        slider.slick('slickSetOption', 'autoplay', !isAutoplay, true);
      }
      setIsAutoplay(!isAutoplay);
    };

    const handleUpdateLogos = (newLogos) => {
      const slider = $('[data-slider=clients]');
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
      setAttributes({ logos: newLogos });
    };

    useEffect(() => {
      clientSlider(isAutoplay);
    }, [logos, isAutoplay]);

    const onSelectLogos = (newLogos) => {
      handleUpdateLogos(newLogos.map(logo => logo.url));
    };

    const onRemoveLogo = (removeIndex) => {
      const newLogos = logos.filter((_, index) => index !== removeIndex);
      handleUpdateLogos(newLogos);
    };

    return (
      <div className="client-logos-editor">
        <MediaUploadCheck>
          <MediaUpload
            onSelect={onSelectLogos}
            allowedTypes={['image']}
            multiple
            gallery
            render={({ open }) => (
              <Button onClick={open} isDefault>Add Client Logos</Button>
            )}
          />
        </MediaUploadCheck>
        <Button onClick={toggleAutoplay} isDefault>
          {isAutoplay ? 'Stop Autoplay' : 'Start Autoplay'}
        </Button>

        <div className="clients-carousel-section">
          <div className="inner">
            <div className="clients-carousel-container">
              <div className="section-header">
                <RichText
                  tagName="span"
                  className={'caption'}
                  value={header}
                  onChange={(newHeader) => setAttributes({header: newHeader})}
                />
              </div>
              <div className="clients-carousel-slider">
                <div data-slider="clients" className="clients-carousel-slider-items">
                  {logos.map((logo, index) => (
                    <div key={index} className="clients-carousel-slider-item">
                      <img src={logo} alt={`Logo ${index + 1}`} />
                      <button
                        onClick={() => onRemoveLogo(index)}
                        className="remove-logo-button"
                        aria-label="Remove logo"
                      >
                        <span className="remove-icon">×</span>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },

  save: ({ attributes }) => {
    return (
      <section className="clients-carousel-section">
        <div className="inner">
          <div className="clients-carousel-container">
            <div className="section-header">
              <RichText.Content className={'caption'} tagName="span" value={attributes.header}/>
            </div>
            <div className="clients-carousel-slider">
              <div data-slider="clients" className="clients-carousel-slider-items">
                {attributes.logos.map((logo, index) => (
                  <img className="clients-carousel-slider-item" key={index} src={logo} alt={`Logo ${index + 1}`} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  },
});
